<!--
  系统维护中
  lovi 2020-3-19
-->
<template>
  <div class="w100 maintain">
    <template v-if="maintainFlag">
      <img class="pic" :src="httpUrl + maintainData" />
      <h3>{{ maintainData.content }}</h3>
      <div class="button-wrap">
        <van-button type="primary" to="/service">
          {{ $t("withdraw.onlineServiceCustomer") }}
        </van-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "maintain",
  meta: {
    power: false
  },
  components: {},
  data() {
    return {
      maintainFlag: false,
      maintainData: {}
    };
  },
  created() {
    this.getHomeData();
  },
  mounted() {},
  computed: {},
  methods: {
    getHomeData() {
      let vm = this;
      clearTimeout(vm.timer);
      vm.$post("/app/index/index", {}, { alert: true })
        .then(res => {
          console.log("index", res);
          if (res.code == 0) {
            vm.$router.push({
              path: "/home"
            });
          }
          if (res.code == 10000) {
            vm.maintainFlag = true;
            vm.maintainData = res.data;
            vm.timer = setTimeout(() => {
              vm.getHomeData();
            }, 3000);
          }
        })
        .catch(error => {
          // 错误信息
          console.log("接口錯誤信息", error);
          vm.timer = setTimeout(() => {
            vm.getHomeData();
          }, 3000);
        });
    }
  },
  watch: {},
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>

<style lang="less" scoped>
.maintain {
  text-align: center;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  flex-flow: column;
  .pic {
    margin: 0 auto;
    max-width: 300px;
  }
  h3 {
    padding: 20px 0;
    font-weight: 20px;
    font-weight: 400;
    line-height: 1;
  }
  .button-wrap {
    margin: 0;
    /deep/.van-button {
      min-width: 150px;
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
